import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/app/services/core/odata'
import { IModelBase } from 'common-components'
import { ODataService } from 'common-services'

export interface ILocationCoverageStateInclusionType extends IModelBase {
  MarketId: number
  StateId: number
}

@Injectable()
export class LocationCoverageStateInclusionODataService extends ODataService<ILocationCoverageStateInclusionType> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'LocationCoverageStateInclusions'
  }
}
